import { useState } from "react";
import "../styles/contact.css";

export default function Contact() {
	const [email, setEmail] = useState("");
	const [subject, setSubject] = useState("");
	const [text, setText] = useState("");
	const [status, setStatus] = useState(null);

	const submit = async (e) => {
		e.preventDefault();
		setStatus("sending");
		try {
			const res = await fetch(`/festivalaki/contact`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ email, subject, text })
			});
			if (!res.ok) throw new Error("send-failed");
			setStatus("sent");
			setEmail("");
			setSubject("");
			setText("");
		} catch (err) {
			console.error(err);
			setStatus("error");
		}
	};

	return (
		<div className="contact-page page-container">
			<div className="contact-form-container">
				<h2>Contact</h2>
				<div className="contact-grid">
					<form className="contact-form" onSubmit={submit}>
						<label>
							Email
							<input
								type="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
							/>
						</label>
						<label>
							Subject
							<input
								type="text"
								value={subject}
								onChange={(e) => setSubject(e.target.value)}
								required
							/>
						</label>
						<label>
							Message
							<textarea
								value={text}
								onChange={(e) => setText(e.target.value)}
								rows={6}
								required
							/>
						</label>
						<div className="submit-row">
							<button className="btn-primary contact-submit" type="submit">
								SEND
							</button>
							<div className="submit-status">
								{status === "sending" && <span className="submit-sending">Sending…</span>}
								{status === "sent" && <span className="submit-success">Your message has been sent</span>}
								{status === "error" && <span className="submit-error">Error, please try again</span>}
							</div>
						</div>
					</form>
				</div>
			</div>
			<div className="contact-links">
				<h3>Follow us</h3>
				<p className="social-icons">
					<a href="https://www.facebook.com/cretanswingshots/" target="_blank" rel="noreferrer">
						<img src="/facebook.png" alt="Facebook" className="social-icon facebook" />
					</a>
					<a href="https://www.instagram.com/cretanswingshots/" target="_blank" rel="noreferrer">
						<img src="/instagram.png" alt="Instagram" className="social-icon instagram" />
					</a>
				</p>
			</div>
		</div>
	);
}
